import axios from "axios"
import { getToken } from "@/utils/auth"
import { MessageBox, Message } from "element-ui"
import Router from "@/router"

const getBaseURL = function () {
  if (process.env.VUE_APP_PLATFORM == "xx") {
    return "http://47.107.83.107:9101/contribute/"
  } else if (process.env.VUE_APP_PLATFORM == "zx") {
    return "http://47.107.83.107:9102/contribute/"
  } else if (process.env.VUE_APP_PLATFORM == "dx") {
    return "http://47.107.83.107:9103/contribute/"
  } else if (process.env.VUE_APP_PLATFORM == "cxzw") {
    return "http://47.107.83.107:9104/contribute/"
  } else {
    return "http://47.107.83.107:8083/contribute/"
  }
}
/**
 * 创建axios 实例
 */
const http = axios.create({
  //baseURL: "http://47.107.83.107:8083/contribute/",
  //baseURL: "http://47.107.83.107:9102/contribute/",
  //baseURL: "http://47.107.83.107:9101/contribute/",
  baseURL: getBaseURL(),
  //baseURL: "http://localhost:8082/",

  //启用代理
  //baseURL: "/apis/",
  timeout: 1200000, //单位毫秒
})

//application/json
http.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded"
http.defaults.headers.common["Authorization"] = getToken()

/**
 * 请求拦截器
 */
http.interceptors.request.use(
  (config) => {
    config.headers.Authorization = getToken()

    let url = config.url
    if (config.method === "get") {
      url.indexOf("?") === -1 ? (config.url = url + "?_=" + new Date().getTime()) : (config.url = url + "&_=" + new Date().getTime())
    }
    return config //  有且必须有一个config对象被返回
  },
  (error) => {
    //   对请求错误做些什么
    console.log("请求有误")
    console.log(error)
    return Promise.reject(error)
  }
)

/**
 * 响应拦截器
 */
http.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      if (response.data.code == 500) {
        Message.warning("系统错误，请跟技术人员联系")
        return Promise.reject(response)
      } else if (response.data.code == 1000) {
        MessageBox.alert("登录超时，请重新登录", "系统提示", {
          confirmButtonText: "确定",
          showClose: false,
          callback: () => {
            Router.push("/login").catch(() => {})
          },
        })
        return Promise.reject(response)
      } else if (response.data.code == 1002) {
        Message.warning("您没有权限")
        return Promise.reject(response)
      }
      return Promise.resolve(response.data)
    } else if (response.status === 500) {
      Message.warning("系统错误500，请跟技术人员联系")
      return Promise.reject(response.data.msg)
    } else if (response.status === 404) {
      Message.warning("系统错误400，请跟技术人员联系")
      return Promise.reject(response.data)
    } else {
      return Promise.reject(response)
    }
  },

  (error) => {
    if (error.toString().indexOf("Network") != -1) {
      Message.error({ message: "网络错误，请跟技术人员联系", showClose: true })
    } else if (error.toString().indexOf("timeout") != -1) {
      Message.error({ message: "网络请求超时", duration: 0, showClose: true })
    }
    return Promise.reject(error)
  }
)

export default http
